module.exports = __webpack_public_path__ + "static/media/cricket-ico.22f6a007.png";